/**
 * eslint-disable no-restricted-globals
 *
 * @format
 */

import { useState } from "react";
import { Button, Card, Icon, Input, Select } from "semantic-ui-react";
import api from "../services/api";
const CUSTOMER_RESOURCES = [
  "MSTR",
  "Gold",
  "VideoAds",
  "RequireUSDTGuaranteed",
  "Ticket",
  "Experience",
];
function CheatTransaction({ userId }: any) {
  const [amount, setAmount] = useState(0);
  const [resource, setResource] = useState(0);
  async function hack() {
    try {
      let rs = await api.post("/cheat/create-transaction", {
        resource,
        amount,
        user_id: userId,
      });
      alert("SUCCESS");
    } catch (error) {
      alert("FAILED");
    }
  }
  return (
    <div>
      <p className="font-bold">Create Transaction</p>
      <div className="flex flex-wrap gap-2">
        <div className="w-[400px] inline">
          <label className="w-full">Type (*)</label>
          <Select
            value={resource}
            fluid
            onChange={(evt, { value }) => {
              setResource(Number(value));
            }}
            options={CUSTOMER_RESOURCES.map((i, index) => {
              return { text: i, value: index };
            })}
          />
        </div>
        <div className="w-[400px] inline">
          <label className="mr-2 w-full">Amount</label>
          <Input
            value={amount}
            className="w-[400px]"
            type="number"
            onChange={(evt: any) => {
              setAmount(evt.target.value);
            }}
          />
        </div>
        <div className="inline">
          <label className="w-full">&nbsp;</label>
          <div>
            <Button
              content="Hack"
              color="blue"
              icon="check"
              onClick={() => {
                hack();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
function CheatLevel({ userId }: any) {
  const [level, setLevel] = useState(0);
  async function hack() {
    try {
      let rs = await api.post("/cheat/set-level", {
        level,
        user_id: userId,
      });
      alert("SUCCESS");
    } catch (error) {
      alert("FAILED");
    }
  }
  return (
    <div>
      <p className="font-bold">Set Level</p>
      <div className="flex flex-wrap gap-2">
        <div className="w-[400px] inline">
          <label className="mr-2 w-full">Level</label>
          <Input
            value={level}
            className="w-[400px]"
            type="number"
            onChange={(evt: any) => {
              setLevel(evt.target.value);
            }}
          />
        </div>
        <div className="inline">
          <label className="w-full">&nbsp;</label>
          <div>
            <Button
              content="Hack"
              color="blue"
              icon="check"
              onClick={() => {
                hack();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
function CheatTut({ userId }: any) {
  const [tut, setTut] = useState(0);
  async function hack() {
    try {
      let rs = await api.post("/cheat/set-tut", {
        tut,
        user_id: userId,
      });
      alert("SUCCESS");
    } catch (error) {
      alert("FAILED");
    }
  }
  return (
    <div>
      <p className="font-bold">Set Tutorial</p>
      <div className="flex flex-wrap gap-2">
        <div className="w-[400px] inline">
          <label className="mr-2 w-full">Tut</label>
          <Input
            value={tut}
            className="w-[400px]"
            type="number"
            onChange={(evt: any) => {
              setTut(evt.target.value);
            }}
          />
        </div>
        <div className="inline">
          <label className="w-full">&nbsp;</label>
          <div>
            <Button
              content="Hack"
              color="blue"
              icon="check"
              onClick={() => {
                hack();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
function CheatPet({ userId }: any) {
  const [level, setLevel] = useState(0);
  async function hack() {
    try {
      let rs = await api.post("/cheat/add-pet", {
        level,
        user_id: userId,
      });
      alert("SUCCESS");
    } catch (error) {
      alert("FAILED");
    }
  }
  return (
    <div>
      <p className="font-bold">Create Pet</p>
      <div className="flex flex-wrap gap-2">
        <div className="w-[400px] inline">
          <label className="mr-2 w-full">Level</label>
          <Input
            value={level}
            className="w-[400px]"
            type="number"
            onChange={(evt: any) => {
              setLevel(Number(evt.target.value));
            }}
          />
        </div>
        <div className="inline">
          <label className="w-full">&nbsp;</label>
          <div>
            <Button
              content="Hack"
              color="blue"
              icon="check"
              onClick={() => {
                hack();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default function Cheat() {
  const [userId, setUserId] = useState(0);
  return (
    <div>
      <h3 className="text-center text-3xl font-bold">Cheat</h3>
      <Card fluid>
        <Card.Content>
          <p className="font-bold">User Info</p>
          <div>
            <label className="mr-2">User ID (*)</label>
            <Input
              value={userId}
              className="w-[400px]"
              onChange={(evt: any) => {
                setUserId(Number(evt.target.value));
              }}
            />
          </div>
        </Card.Content>
        {userId !== 0 && (
          <>
            <Card.Content>
              <CheatTransaction userId={userId} />
            </Card.Content>
            <Card.Content>
              <CheatLevel userId={userId} />
            </Card.Content>
            <Card.Content>
              <CheatPet userId={userId} />
            </Card.Content>
            <Card.Content>
              <CheatTut userId={userId} />
            </Card.Content>
          </>
        )}
      </Card>
    </div>
  );
}
